import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-everything-about-cat',
  templateUrl: './everything-about-cat.component.html',
  styleUrls: ['./everything-about-cat.component.scss']
})
export class EverythingAboutCatComponent {

  @Input('pageType') pageType:any;

  @Input('selectedIndex') selectedIndex:any;

  @Output() gocourses = new EventEmitter<string>()

  gotocourses(){
    this.gocourses.emit('test')
  }

}
